<template>
  <div class="mk-autoweb-book-list">
    <h2>白皮书下载</h2>
    <div class="mk-autoweb-book-list-content">
      <ul>
        <li v-for="(item, index) in childItem.propsValue.data.customField1" :key="index">
          <img :src="item.customField2.afterClick.contentImage" />
          <p>{{ item.customField2.afterClick.contentName }}</p>
          <button>{{ item.customField2.text }}</button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "MkBaipishuMultipleWeb",
  props: {
    childItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      fields: [
        {
          code: "customField1",
          label: "白皮书",
          type: "list",
          min: 2,
          max: 5,
          children: [
            {
              code: "customField2",
              label: "",
              type: "button"
            }
          ]
        }
      ],
      data: {
        customField1: [
          {
            customField2: {
              afterClick: {
                contentId: "",
                contentImage: "",
                contentName: "",
                contentType: "data",
                type: 2,
                url: ""
              },
              beforeClick: {
                form: "",
                formtime: "一天",
                type: 0
              },
              text: "下载"
            }
          },
          {
            customField2: {
              afterClick: {
                contentId: "",
                contentImage: "",
                contentName: "",
                contentType: "data",
                type: 2,
                url: ""
              },
              beforeClick: {
                form: "",
                formtime: "一天",
                type: 0
              },
              text: "下载"
            }
          }
        ]
      }
    };
  }
};
</script>

<style scoped lang="scss">
.mk-autoweb-book-list {
  width: 100%;
  padding-top: 138px;
  position: relative;
}

.mk-autoweb-book-list h2 {
  position: absolute;
  top: 36px;
  left: 0;
  right: 0;
  margin: 0 auto;
  font-size: 22px;
  line-height: 30px;
  letter-spacing: 2px;
  color: #e31924;
  font-weight: bold;
  text-align: center;
}

.mk-autoweb-book-list .mk-autoweb-book-list-content {
  width: 880px;
  box-shadow: 0px 0px 24px 0px rgba(19, 19, 19, 0.1);
  border-radius: 6px;
  margin: 0 auto;
}

.mk-autoweb-book-list .mk-autoweb-book-list-content ul {
  margin: 0 44px;
  padding: 22px 0;
  display: flex;
  justify-content: center;
  align-content: space-between;
}

.mk-autoweb-book-list .mk-autoweb-book-list-content ul li {
  width: 20%;
  text-align: center;
  border-right: 1px solid #d0d0d0;
}

.mk-autoweb-book-list .mk-autoweb-book-list-content ul li:last-child {
  border-right: none;
}

.mk-autoweb-book-list .mk-autoweb-book-list-content ul li img {
  width: 88px;
  height: 120px;
  margin-top: -66px;
}

.mk-autoweb-book-list .mk-autoweb-book-list-content ul li p {
  font-size: 12px;
  color: #6f6f6f;
  text-align: center;
  height: 32px;
  line-height: 16px;
  padding: 0 22px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.mk-autoweb-book-list .mk-autoweb-book-list-content ul li button {
  width: 80px;
  height: 26px;
  background: linear-gradient(135deg, #e97528 0%, #e90713 100%);
  border: none;
  border-radius: 3px;
  font-size: 12px;
  color: #ffffff;
  margin-top: 11px;
}
</style>
